import { SiPython } from 'react-icons/si'

export const PythonTech = () => {
    return (
        <div>
        <SiPython />
        <h4>Python</h4>
        </div>
    )
}